import { render, staticRenderFns } from "./TabBlock.vue?vue&type=template&id=4f2d774a&scoped=true"
import script from "./TabBlock.vue?vue&type=script&lang=js"
export * from "./TabBlock.vue?vue&type=script&lang=js"
import style0 from "./TabBlock.vue?vue&type=style&index=0&id=4f2d774a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2d774a",
  null
  
)

export default component.exports